export default __webpack_public_path__ + "static/media/Prancheta AC 2-2.b6716efe.svg";